export const WORKSPACE_MODE = {
  TEAM_COLLABORATION: 'TEAM_COLLABORATION',
  DATA_MANAGEMENT: 'DATA_MANAGEMENT',
  REFERENCE_FILES: 'REFERENCE_FILES',
  FORM_SUBMISSION_VIEW: 'FORM_SUBMISSION_VIEW',
  LOADER_VIEW: 'LOADER_VIEW',
  STATUS_LIFECYCLE: 'STATUS_LIFECYCLE',
  ACTIVITY_ALL_DETAILS_VIEW:'ACTIVITY_ALL_DETAILS_VIEW',
  INFO:'INFO',
  PARTICIPANTS:'PARTICIPANTS',
  TEAMS:'TEAMS'
};
